import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HouseCreditTransactionService } from '../../services/house-credit-transaction.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-house-credit-modal',
  templateUrl: './house-credit-modal.component.html',
  styleUrl: './house-credit-modal.component.scss'
})
export class HouseCreditModalComponent implements OnInit {

  @Input() mode: 'deposit' | 'refund' = 'deposit';
  @Input() maxAmount?: number;
  @Input() neighborhoodId: string = '';
  @Input() streetBuildingId: string = '';
  @Input() houseFlatId: string = '';

  public form: FormGroup;
  public submitted = false;
  public saving = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private houseCreditTransactionService: HouseCreditTransactionService,
    private toastService: ToastService,
  ) {
    this.form = this.formBuilder.group({
      amount: [null, [Validators.required, Validators.min(0.01)]],
      notes: [''],
    });
  }

  /*
  ███╗   ██╗ ██████╗ ██╗███╗   ██╗██╗████████╗
  ████╗  ██║██╔════╝ ██║████╗  ██║██║╚══██╔══╝
  ██╔██╗ ██║██║  ███╗██║██╔██╗ ██║██║   ██║
  ██║╚██╗██║██║   ██║██║██║╚██╗██║██║   ██║
  ██║ ╚████║╚██████╔╝██║██║ ╚████║██║   ██║
  ╚═╝  ╚═══╝ ╚═════╝ ╚═╝╚═╝  ╚═══╝╚═╝   ╚═╝

  */
  // region ngOnInit
  ngOnInit() {
    if (this.mode === 'refund' && this.maxAmount != null) {
      this.form.get('amount')!.addValidators(Validators.max(this.maxAmount));
      this.form.get('amount')!.updateValueAndValidity();
    }
  }

  get formControls() {
    return this.form.controls;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  // region onSubmit
  async onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    this.saving = true;

    try {
      const payload = {
        amount: this.form.value.amount,
        notes: this.form.value.notes ?? '',
      };

      let result;
      if (this.mode === 'deposit') {
        result = await this.houseCreditTransactionService.deposit(
          this.neighborhoodId,
          this.streetBuildingId,
          this.houseFlatId,
          payload,
        );
      } else {
        result = await this.houseCreditTransactionService.refund(
          this.neighborhoodId,
          this.streetBuildingId,
          this.houseFlatId,
          payload,
        );
      }

      if (result) {
        this.activeModal.close();
      }
    } catch (error) {
      console.error(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white',
      });
    } finally {
      this.saving = false;
    }
  }

}
